import React from 'react';
import { StyledSelect } from './styles';

export const Select: React.FC<any> = ({ ...rest }: any) => {
  return <StyledSelect {...rest} />;
};
